import { useEffect, useState } from 'react';
import axios from 'axios';
import { useLanguage } from '../i18n/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SCRIPT_ID = 'elevenlabs-convai-script';
const SCRIPT_SRC = 'https://unpkg.com/@elevenlabs/convai-widget-embed';

const VoiceAssistantWidget = () => {
  const [agentId, setAgentId] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/voice-agent/info`);
        if (mounted && data?.enabled && data?.agent_id) {
          setAgentId(data.agent_id);
        }
      } catch (e) { /* silent */ }
    })();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (!agentId) return;
    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      script.type = 'text/javascript';
      document.body.appendChild(script);
    }
  }, [agentId]);

  if (!agentId) return null;

  const labelText = language === 'es' ? 'Asistente IA' : 'AI Assistant';

  return (
    <>
      {/* Standalone label — does NOT wrap the widget so clicks pass through */}
      <span className="voice-widget-label" aria-hidden="true">{labelText}</span>
      {/* The widget is rendered as a sibling, free to handle its own pointer events */}
      <elevenlabs-convai agent-id={agentId} data-testid="voice-assistant-widget"></elevenlabs-convai>
    </>
  );
};

export default VoiceAssistantWidget;
